<div class="skeleton-loader">
    <div *ngIf="showHeader" class="skeleton-header"></div>
    <div class="skeleton-body">
        <div
            *ngFor="let line of lines; let i = index"
            class="skeleton-line"
            [style.height.px]="lineHeight"
            [style.width.%]="getLineWidth(i)">
        </div>
    </div>
</div>
